const checkHubspotLoadedAndAddFuncToQueue = (callback) => {
  if (document.getElementById('hubspot-conversations-iframe') && typeof callback === 'function') {
    callback();
  } else {
    setTimeout(() => {
      checkHubspotLoadedAndAddFuncToQueue(callback);
    }, 500);
  }
};

const addChatbotWidget = (onLoadCallback) => {
  // Check if it already exists
  if (document.getElementById('hs-script-loader')) return;
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.defer = true;
  script.id = 'hs-script-loader';
  script.src = 'https://js-na1.hs-scripts.com/24421359.js';

  document.body.appendChild(script);

  checkHubspotLoadedAndAddFuncToQueue(onLoadCallback);
};

export {
  addChatbotWidget,
};
